import { postWithAuth, getWithAuth } from "../../../Basic/HttpService";

export const postVorSubCatData = async (data) => {
    let res = await postWithAuth(`vorsubcategories`, data);
    return res;
};